import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import connect from "react-redux/es/connect/connect";
import FusePageCarded from "../../../@fuse/components/FusePageLayouts/FusePageCarded";

import {API} from "../../../config";
import { companySelector } from '../../../store/reducers/company.reducer';
import Custodian from './components/custodian';
import Internal from './components/internal';
import _ from 'lodash';
import {Button, Input, Typography} from "@material-ui/core";

const moment = require('moment');

const companies = API.service('company');
const brokers = API.service('authorized-brokers');

const styles = theme => ({
  layoutRoot: {
    backgroundColor: '#23272f',
    display: 'flex',
    flex: 1,
    height: '100vh',
    overflow: 'hidden'
  },
  container: {
    flex: '1 0 auto',
  },
  content: {
    minHeight:'1000px',
    padding: 10,
    backgroundColor: '#23272f',
  },
  dataContainer: {
    height: 'calc(100% - 148px)',
    marginTop: 20,
  },
  tabRoot: {
    minWidth: 100,
  },
  tabcontent: {
    borderTop: "1px solid #1890ff"
  },
  textBox: {
    border: '1px solid white',
    borderRadius: 12,
    fontSize: 12,
    height: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45%',
    color: 'white',
    margin: theme.spacing.unit,
  },
  row: {
    height: "auto",

    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  },
  cell: {
    padding: '4px 8px 4px 8px'
  },
  flexBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#23272f',

    '&.center': {
      alignItems: 'center',
    }
  },
});

class Settlement extends Component {
  state = {
    loading:true,
    companies:false,
    brokers:false,
    completed_trades:false,
    certificates:false,
    opening:false,
    startDate:moment().subtract('1','Month').format('YYYY-MM-DD'),
    endDate:moment().format('YYYY-MM-DD'),
  };

  loadData = () =>{
    const app = this;

    companies.find({query:{_status:0,$limit:1000}}).then((c)=>{
      app.setState({
        companies:c.data
      })
    }); //companies.find

    brokers.find({query:{$limit:1000}}).then((b)=>{
      app.setState({
        brokers:b.data
      })
    }); //companies.find
  }

  componentDidMount() {

  }

  updateDate = (event) => {
    this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    this.setState({companies:false,brokers:false});
  }

  render() {
    const { classes } = this.props

    return (
      <FusePageCarded
        classes={{
          root: classes.layoutRoot
        }}
        header={
          <div />
        }
        content={
          <div className={classes.content}>
            Start Date:<br />
            <Input
              type={"date"}
              name={'startDate'}
              value={this.state.startDate}
              onChange={this.updateDate}
              style={{
                color: 'black',
                background: 'white',
                borderRadius:'3px',
                padding:'5px'
              }}
            /><br /><br/>
            End Date:<br />
            <Input
                type={"date"}
                name={'endDate'}
                value={this.state.endDate}
                onChange={this.updateDate}
                style={{
                  color: 'black',
                  background: 'white',
                  borderRadius:'3px',
                  padding:'5px'
                }}
            /><br /><br/>
            <Button variant="raised"
                    color="secondary"
                    onClick={this.loadData}>
              Generate
            </Button>

            {(this.state.companies) &&
              <React.Fragment>
                <Typography style={{marginTop:'40px'}} variant={'title'}>Custodian Report: {this.state.startDate} - {this.state.endDate}</Typography>
                {this.state.companies.map((v, i) => {
                  return (
                      <div key={i} style={{marginTop:'45px'}}>
                        <Typography variant={'title'}>{v._company_name}</Typography>
                        <Custodian
                          company={v._company_account}
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                         />
                      </div>
                  )
                })}
              </React.Fragment>
            }



            {(this.state.brokers) &&
            <React.Fragment>
              <Typography style={{marginTop:'40px'}} variant={'title'}>USD Broker Settlement Statement: {this.state.startDate} - {this.state.endDate}</Typography>
              {this.state.brokers.map((v, i) => {
                return (
                    <div key={i} style={{marginTop:'45px'}}>
                      <Typography variant={'title'}>{v._name}</Typography>
                      <Internal
                        broker={v}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                      />
                    </div>
                )
              })}
            </React.Fragment>
            }

          </div>
        }
      />
    )
  }
}

const mapStateToProps = state => ({
  selectedCompany: companySelector(state),
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(withRouter(Settlement)));
